import {
    DeviceCompliancePolicyAssignment,
    DeviceManagementConfigurationPolicy,
} from '@microsoft/microsoft-graph-types-beta';
import { createAction, props } from '@ngrx/store';

export const loadDeviceConfigurationPolicies = createAction(
    '[Graph/Device Configurations] Load Device Configuration Policies',
    props<{ _tenant: string }>(),
);

export const loadDeviceConfigurationPoliciesSuccess = createAction(
    '[Graph/Device Configurations] Load Device Configurations Success',
    props<{ _tenant: string; data: DeviceManagementConfigurationPolicy[] }>(),
);

export const loadDeviceConfigurationPoliciesFailure = createAction(
    '[Graph/Device Configurations] Load Device Configuration Policies Failure',
    props<{ _tenant: string; error: any }>(),
);

export const getOneConfigurationPolicy = createAction(
    '[Graph/Device Configurations] Get One Device Configuration Policy',
    props<{ _tenant: string; id: string }>(),
);

export const getOneConfigurationPolicySuccess = createAction(
    '[Graph/Device Configuration Policies] Get one Device Configuration Policy Success',
    props<{ _tenant: string; data: DeviceManagementConfigurationPolicy[] }>(),
);

export const getOneConfigurationPolicyFailure = createAction(
    '[Graph/Device Configuration Policies] Get One Device Configuration Policy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const createConfigurationPolicy = createAction(
    '[Graph/Device Configuration Policies] Create Device Configuration Policies ',
    props<{
        _tenant: string;
        policy: Omit<DeviceManagementConfigurationPolicy, 'id' | 'assignments'>;
        assignments: DeviceCompliancePolicyAssignment[];
    }>(),
);

export const createConfigurationPolicySuccess = createAction(
    '[Graph/Device Configuration Policies] Create Device Configuration Policies Success',
    props<{ _tenant: string; policy: DeviceManagementConfigurationPolicy }>(),
);

export const createConfigurationPolicyFailure = createAction(
    '[Graph/Device Configuration Policies] Create Device Configuration Policies Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateConfigurationPolicy = createAction(
    '[Graph/Device Configuration Policies] Update Device Configuration Policies ',
    props<{
        _tenant: string;
        id: string;
        policy: Omit<DeviceManagementConfigurationPolicy, 'id' | 'assignments'>;
        assignments: DeviceManagementConfigurationPolicy[];
        // settings: DeviceManagementConfigurationSetting[];
    }>(),
);

export const updateConfigurationPolicySuccess = createAction(
    '[Graph/Device Configuration Policies] Update Device Configuration Policies Success',
    props<{ _tenant: string; policy: DeviceManagementConfigurationPolicy }>(),
);

export const updateConfigurationPolicyFailure = createAction(
    '[Graph/Device Configuration Policies] Update Device Configuration Policies Failure',
    props<{ _tenant: string; error: any }>(),
);

export const deleteConfigurationPolicy = createAction(
    '[Graph/Device Configuration Policies] Delete Device Configuration Policies ',
    props<{ _tenant: string; id: string }>(),
);

export const deleteConfigurationPolicySuccess = createAction(
    '[Graph/Device Configuration Policies] Delete Device Configuration Policies Success',
    props<{ _tenant: string; id: string }>(),
);

export const deleteConfigurationPolicyFailure = createAction(
    '[Graph/Device Configuration Policies] Delete Device Configuration Policies Failure',
    props<{ _tenant: string; error: any }>(),
);
